export const SET_LEADER_BOARD_LOADING = 'SET_LEADER_BOARD_LOADING'
export const SET_LEADER_BOARD_CATEGORIES = 'SET_LEADER_BOARD_CATEGORIES'
export const SET_LEADER_BOARD_MODAL_DATA = 'SET_LEADER_BOARD_MODAL_DATA'
export const SET_LEADER_BOARD_DETAILED = 'SET_LEADER_BOARD_DETAILED'
